import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useNotifications } from 'contexts/NotificationsContext';
import { ArrowRight, MessageSquareMore } from 'lucide-react';

type DropdownUserProps = {
  setIsNotificationDropdownOpen: (open: boolean) => void;
};

const DropdownNotification: React.FC<DropdownUserProps> = ({
  setIsNotificationDropdownOpen,
}) => {
  const { courseId } = useParams<{ courseId: string }>();
  const { notifications, markAsRead, loading } = useNotifications();

  return (
    <div className="absolute right-0 top-full mt-2 w-60 lg:w-72 bg-white rounded-xl shadow-lg border border-gray-200 py-2 z-50 animate-in fade-in slide-in-from-top-2 duration-200">
      <div>
          <h4 className="border-b last:border-0 p-3 text-gray-700 font-bold">
            Notificações
          </h4>
          
          {loading ? (
            // Spinner de loading
            <div className="flex justify-center items-center p-6">
              <div className="w-6 h-6 border-4 border-gray-300 border-t-gray-500 rounded-full animate-spin"></div>
            </div>
          ) : notifications.length === 0 ? (
            <div className="p-4 text-gray-500 text-sm">Nenhuma notificação</div>
          ) : (
            <ul>
              {notifications.map((n) => (
                <li
                  key={n.id}
                  className="border-b last:border-0  hover:bg-terracota/10"
                >
                  <Link
                    to={`/aluna/${courseId}/posts/${n.postId}#${n.commentId}`}
                    className="flex items-start gap-2 p-3 text-sm text-gray-700"
                    onClick={async () => {
                      await markAsRead(n.id);
                      setIsNotificationDropdownOpen(false);
                    }}
                  >
                    <MessageSquareMore color="#374151d3" size={25}/>
                    <div className="flex items-center text-gray-700"><p>{n.message} <span className="text-terracota underline">ver publicação</span></p><ArrowRight size={25} color="#374151d3" /></div>
                  </Link>
                </li>
              ))}
            </ul>
          )}
      </div>
    </div>
  );
};

export default DropdownNotification;
